module.exports = "<div class='main' *ngIf='project'>\n  <div *ngFor='let tpl of userLs'\n      class='user'>\n    <span class='owner'\n        *ngIf='tpl[2]'>Owner: {{tpl[1]}}</span>\n    <label *ngIf='!tpl[2]'>\n      <input\n      type='checkbox'\n      [checked]='tpl[3]'\n       (click)='switchUser(tpl[0])'> {{tpl[1]}}\n    </label>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/edit-project-users-box/edit-project-users-box.component.html
// module id = ../../../../../src/app/edit-project-users-box/edit-project-users-box.component.html
// module chunks = main